"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_232)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_232`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.40002 0H30.6V24H-5.40002V0Z",
					fill: "#E30A17"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.8245 8.32288C11.9052 7.65621 10.7894 7.29831 9.64554 7.30533C6.78239 7.30533 4.4666 9.46674 4.4666 12.1404C4.4666 14.8141 6.7894 16.9755 9.64554 16.9755C10.8455 16.9755 11.9543 16.5966 12.8245 15.958C10.7192 18.6667 6.81046 19.158 4.10168 17.0457C1.39291 14.9334 0.901685 11.0316 3.01397 8.32288C5.12625 5.6141 9.028 5.12288 11.7368 7.23516C12.1438 7.55095 12.5087 7.92288 12.8245 8.32288ZM15.6245 12.9404L14.3543 14.4773L14.4385 12.4843L12.5859 11.7545L14.5017 11.2211L14.628 9.23516L15.7227 10.8983L17.6526 10.4001L16.4245 11.9439L17.4982 13.6211L15.6245 12.9404Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_232`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TRFlag };
